// REACT IMPORTS
import React, { useEffect, useState } from "react";

// ICON IMPORTS
import { Checkcon } from "icons/toast/Checkcon";
import { CloseIcon } from "icons/toast/CloseIcon";
import { CloseCircleIcon } from "icons/toast/CloseCircleIcon";
import { InfoCircleIcon } from "icons/warning/InfoCircleIcon";

// PROPS TYPE
interface MessageToastProps {
  onCloseClick?: any;
  variant?: "success" | "error" | "warning" | "";
  width?: string;
  content: string | null;
  isSubscribe?: boolean;
  isProgressBar?: boolean;
  className?: string;
}

/* ------------------------------------- MESSAGE TOST ------------------------------------- */

const MessageToast = (props: MessageToastProps) => {
  const {
    onCloseClick,
    variant,
    width,
    content = "",
    isSubscribe = false,
    isProgressBar = false,
    className = "",
  } = props;

  const [show, setshow] = useState<boolean>(false);
  useEffect(() => {
    if (!content) {
      setshow(false);
    } else {
      setshow(true);
      setTimeout(() => {
        setshow(false);
        onCloseClick();
      }, 10000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  return (
    <div
      className={`${className} fixed z-[99999999] bottom-10 lg:right-48 right-16 rounded-[8px] overflow-clip ${width ? width : "w-[402px]"}`}
    >
      <div
        className={`rounded-[8px] flex flex-col w-full ${!content && "hidden"}  ${
          variant === "success"
            ? "bg-iconObscure"
            : variant === "warning"
              ? "bg-yellow"
              : "bg-red"
        }  ${
          show
            ? "animate__animated animate__fadeInRight"
            : "animate__animated animate__fadeOutRight"
        }`}
      >
        <div
          className={`flex items-start gap-[12px] w-full ${
            isSubscribe ? "py-[13px]" : "py-2"
          } px-[16px]`}
        >
          {!isSubscribe && (
            <div className="flex items-start">
              {variant === "success" ? (
                <Checkcon />
              ) : variant === "warning" ? (
                <InfoCircleIcon strokeColor="white" aria-hidden="true" />
              ) : (
                <CloseCircleIcon />
              )}
            </div>
          )}
          <div className=" w-full">
            {!isSubscribe && (
              <div className="text-sm font-medium text-white leading-normal -tracking-[-0.28px]">
                {variant === "success"
                  ? "Success"
                  : variant === "warning"
                    ? "Warning"
                    : "Failed"}
              </div>
            )}
            <div
              className={`text-bgThird ${
                isSubscribe ? "text-base" : "text-xs"
              } leading-[18.23px]`}
            >
              {content}
            </div>
          </div>
          <div
            className="cursor-pointer"
            onClick={() => {
              setshow(false);
              onCloseClick();
            }}
          >
            <CloseIcon />
          </div>
        </div>
        {isProgressBar && (
          <div
            style={{
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }}
            className="portal-remainingTimeIndicator rounded-b-[8px] w-full h-1 bg-strokeActive "
          />
        )}
      </div>
    </div>
  );
};

export default MessageToast;
